<template>
  <vue-scroll>
  <div class="guarantee-list">
    
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="filterExpandText">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <!-- Desktop filter form -->
          <Form v-if="!isMobile" ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="保函编号" prop="orderNumber">
                  <Input v-model="filterModel.orderNumber" placeholder="输入保函编号" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="保证人" prop="guarantorName">
                  <Input v-model="filterModel.guarantorName" placeholder="输入保证人名称" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="项目名称" prop="prjId">
                  <Select
                    v-model="filterModel.prjName"
                    filterable
                    remote
                    allow-create
                    @on-select="selectProject"
                    placeholder="输入关键字选择或键入完整名称"
                    :remote-method="searchProjects"
                    :loading="loading">
                    <Option v-for="(option, index) in projects" :value="option.name" :tag="option.id" :key="index">{{option.name}}</Option>
                  </Select>
                  <!-- <Input v-model="filterModel.prjId" placeholder="输入项目名称" /> -->
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="总承包商">
                  <Select
                    v-model="filterModel.contractorName"
                    filterable
                    remote
                    allow-create
                    @on-select="selectContractor"
                    placeholder="输入关键字选择或键入完整名称"
                    :remote-method="searchContractors"
                    :loading="loading">
                    <Option v-for="(option, index) in contractors" :value="option.name" :tag="option.tid" :key="index">{{option.name}}</Option>
                  </Select>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="受益人" prop="beneficiary">
                  <Input v-model="filterModel.beneficiary" placeholder="输入受益人名称" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="被保证人" prop="guaranteed">
                  <Input v-model="filterModel.guaranteed" placeholder="输入被保证人名称" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="类别" style="width: 100%">
                  <Select v-model="filterModel.variety" filterable style="width:200px">
                    <Option v-for="(tp,idx) in varieties" :key="idx" :value="parseInt(tp.id)">{{tp.name}}</Option>
                  </Select>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="地区" style="width: 100%">
                  <Cascader :data="cities" :load-data="loadCityData" @on-change="citySelected" placeholder="选择"></Cascader>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="行业/领域" prop="type" style="width: 100%">
                  <Select v-model="filterModel.industryId" filterable placeholder="选择专属行业/领域">
                    <Option v-for="item in industries" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="保证方式" prop="gMethod">
                  <Select v-model="filterModel.gMethod" filterable style="width:200px">
                    <Option v-for="(tp,idx) in $common.getEnumSelect($common.gMethod)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
                  </Select>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="联系人" prop="opName">
                  <Input v-model="filterModel.opName" placeholder="输入联系人" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="联系电话" prop="opContactTel">
                  <Input v-model="filterModel.opContactTel" placeholder="输入联系电话" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="保额区间(万元)">
                  <Input-Number v-model="filterModel.amountStart" :min="0" :step="10" />
                   -
                  <Input-Number v-model="filterModel.amountEnd" :min="0" :step="10" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="录入日期">
                  <DatePicker v-model="filterModel.daterange"
                    @on-change="filterDateRangeChanged"
                    type="daterange"
                    placement="bottom-end"
                    format="yyyy/MM/dd"
                    placeholder="选择录入日期区间"
                    style="width: 240px"></DatePicker>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="状态">
                  <Select v-model="filterModel.statusList" multiple filterable style="width:200px">
                    <Option v-for="(tp,idx) in $common.getEnumSelect($common.guaranteeStatus)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
                    <Option :value="10">续保待审核</Option>
                  </Select>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="到期时间范围" prop="expireInDays">
                  <Select v-model="filterModel.expireInDays" filterable style="width:200px">
                    <Option :value="-1">已过期</Option>
                    <Option :value="7">7日内过期</Option>
                    <Option :value="15">15日内过期</Option>
                    <Option :value="30">30日内过期</Option>
                    <Option :value="60">60日内过期</Option>
                  </Select>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="审核日期">
                  <DatePicker v-model="filterModel.auditDaterange"
                    @on-change="filterAuditDateRangeChanged"
                    type="daterange"
                    placement="bottom-end"
                    format="yyyy/MM/dd"
                    placeholder="选择审核日期区间"
                    style="width: 240px"></DatePicker>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="解除日期">
                  <DatePicker v-model="filterModel.terminateDaterange"
                    @on-change="filterTerminateDateRangeChanged"
                    type="daterange"
                    placement="bottom-end"
                    format="yyyy/MM/dd"
                    placeholder="选择解除日期区间"
                    style="width: 240px"></DatePicker>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Checkbox v-model="filterModel.showJoint" style="margin-right:50px">显示联保</Checkbox>
                  <Checkbox v-model="filterModel.isElec" style="margin-right:50px">电子保函</Checkbox>
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="resetFilter">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
          <!-- Mobile filter form - single row -->
          <Form v-if="isMobile" ref="filterFormMobile" :model="filterModel" :show-message="false" :label-width="70">
            <div class="mobile-filter-row">
              <FormItem label="保函编号" prop="orderNumber" class="mobile-filter-item">
                <Input v-model="filterModel.orderNumber" placeholder="编号" size="small" />
              </FormItem>
              <FormItem label="项目名称" prop="prjId" class="mobile-filter-item">
                <Select
                  v-model="filterModel.prjName"
                  filterable
                  remote
                  allow-create
                  @on-select="selectProject"
                  placeholder="项目"
                  :remote-method="searchProjects"
                  :loading="loading"
                  size="small">
                  <Option v-for="(option, index) in projects" :value="option.name" :tag="option.id" :key="index">{{option.name}}</Option>
                </Select>
              </FormItem>
            </div>
            <div class="mobile-filter-row">
              <FormItem label="状态" prop="statusList" class="mobile-filter-item">
                <Select v-model="filterModel.statusList" multiple filterable placeholder="状态" size="small">
                  <Option v-for="(tp,idx) in $common.getEnumSelect($common.guaranteeStatus)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
                  <Option :value="10">续保待审核</Option>
                </Select>
              </FormItem>
              <FormItem label="类别" prop="variety" class="mobile-filter-item">
                <Select v-model="filterModel.variety" filterable placeholder="类别" size="small">
                  <Option v-for="(tp,idx) in varieties" :key="idx" :value="parseInt(tp.id)">{{tp.name}}</Option>
                </Select>
              </FormItem>
            </div>
            <div class="mobile-filter-row mobile-filter-row-buttons">
              <Button type="primary" size="small" @click="refresh">查询</Button>
              <Button type="error" ghost size="small" @click="resetFilter">重置</Button>
            </div>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <div>
      <i-button type="primary" :disabled="!selections||!selections.length" @click="exportExcel">导出XLSX</i-button>
      <Button type="default" :disabled="!data||!data.length" @click="openStatModal" style="margin-left: 10px;">统计</Button>
    </div>
    <!-- div class="text-right">
      <Button type="primary" to="/guarantees/new" icon="md-add" v-if="checkRolePermitted('保证人')">新增保函</Button>
    </div -->
    <div class="padding-top-10"></div>
    <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
    <div class="list-table">
      <!-- Desktop table header -->
      <div v-if="!isMobile" class="table-header">
        <table width="100%">
          <colgroup>
            <col width="60">
            <col>
            <col width="120">
            <col width="120">
            <col width="100">
            <col width="100">
            <col width="100">
            <col width="150">
            <col>
          </colgroup>
          <thead>
            <tr>
              <th class="list-table-column" v-for="(col,idx) in columns" :key="idx">
                <Checkbox v-model="selectAll" :indeterminate="indeterminate" @click.prevent.native="handleCheckAll" v-if="col.type==='_selection'"></Checkbox>
                <div v-else>
                  <span v-if="!col.sortable">{{col.title}}</span>
                  <a v-else @click="sortColumn(col)">{{col.title}}</a>
                  <span v-if="currentSortingColumn.key===col.key">
                    <Icon type="ios-arrow-round-up" v-show="currentSortingColumn.ascending===true" />
                    <Icon type="ios-arrow-round-down" v-show="currentSortingColumn.ascending===false" />
                  </span>
                </div>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <!-- Mobile table header -->
      <div v-if="isMobile" class="table-header mobile-table-header">
        <table width="100%">
          <colgroup>
            <col width="50">
            <col>
          </colgroup>
          <thead>
            <tr>
              <th class="list-table-column">
                <Checkbox v-model="selectAll" :indeterminate="indeterminate" @click.prevent.native="handleCheckAll"></Checkbox>
              </th>
              <th class="list-table-column">项目名称</th>
            </tr>
          </thead>
        </table>
      </div>
      <CheckboxGroup v-model="selections" @on-change="checkAllGroupChange">
        <div class="table-body">
          <template v-if="!isMobile">
            <div class="data-row" v-for="(gua,idx) in data" :key="idx">
              <div class="status-badge">
                <Tag v-if="gua.isRenewalAuditing" color="warning">续保待审核</Tag>
                <Tag :color="$common.guaranteeStatusColor[gua.status]">
                  {{$common.guaranteeStatus[gua.status]}}
                </Tag>
                <Tag v-if="gua.gEndDateOri" color="orange">已续保</Tag>
              </div>
              <div class="data-row-header">
                <div class="line">
                  <div class="order-number">
                    <Checkbox :label="gua.id"><Icon type="md-barcode" /> {{gua.orderNumber}}</Checkbox>
                  </div>
                  <Divider type="vertical" />
                  <div class="guarantor-name">
                    <Icon type="md-person" /> {{gua.guarantorName}}
                  </div>
                </div>
              </div>
              <table width="100%">
                <colgroup>
                  <col width="60">
                  <col>
                  <col width="120">
                  <col width="120">
                  <col width="100">
                  <col width="100">
                  <col width="100">
                  <col width="150">
                </colgroup>
                <tbody>
                  <tr>
                    <td class="list-table-column">
                      <Tag color="green" v-if="$common.undergoingStatus.indexOf(gua.status)>-1">在保</Tag>
                      <Tag color="orange" v-if="$common.undergoingStatus.indexOf(gua.status)>-1&&
                        gua.gEndDate&&require('moment')(gua.gEndDate).diff(require('moment')(),'days')<=30&&
                        gua.gEndDate&&require('moment')(gua.gEndDate).diff(require('moment')(),'days')>=0">
                        {{require('moment')(gua.gEndDate).diff(require('moment')(), 'days')}}日到期
                      </Tag>
                      <Tag color="red" v-if="$common.undergoingStatus.indexOf(gua.status)>-1&&
                        gua.gEndDate&&require('moment')(gua.gEndDate).diff(require('moment')(),'days')<0">
                        超期
                      </Tag>
                    </td>
                    <td class="list-table-column text-left">
                      <Tooltip :content="gua.prjName" max-width="200">
                        <router-link :to="'/guarantees/detail/'+gua.orderNumber" class="prjname">{{gua.prjName}}</router-link>
                      </Tooltip>
                    </td>
                    <td class="list-table-column">{{gua.cityName}}</td>
                    <td class="list-table-column">{{gua.industryName||'住建'}}</td>
                    <td class="list-table-column">
                      <Tooltip :content="getVarietyName(gua.variety, true)">
                        <Tag :color="getVarietyTagColor(gua.variety)">{{getVarietyName(gua.variety, false)}}</Tag>
                      </Tooltip>
                      <Tag :color="gua.gMethod===0?'primary':'success'" type="border">{{gua.gMethod===0?'独立保证':'联合保证'}}</Tag>
                    </td>
                    <td class="list-table-column">{{(Math.round(gua.amount / 10000) / 100).toFixed(2)}}</td>
                    <td class="list-table-column">{{gua.gEndDate?require('moment')(gua.gEndDate).format('YYYY-MM-DD'):null}}</td>
                    <td class="list-table-column">
                      <Tooltip content="详情">
                        <Button type="primary"
                          ghost
                          shape="circle"
                          :to="'/guarantees/detail/'+gua.orderNumber"
                          icon="md-list-box"></Button>
                      </Tooltip>&nbsp;
                      <Tooltip
                        v-if="checkRolePermitted('保证人')&&(gua.status===7||gua.status===6)"
                        content="修改">
                        <Button type="warning"
                          ghost
                          shape="circle"
                          @click="edit(gua.orderNumber)"
                          icon="md-create"></Button>
                      </Tooltip>&nbsp;
                      <Tooltip
                        v-if="checkRolePermitted('保证人')&&(gua.status===7||gua.status===6)"
                        content="删除">
                        <Button type="error"
                          ghost
                          @click="remove(gua.orderNumber)"
                          shape="circle"
                          icon="ios-trash-outline"></Button>
                      </Tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="data-row-footer">
                <div class="line">
                  <div class="order-number">
                    <span class="title">被保证人：</span>
                    <span class="content">{{gua.guaranteed}}</span>
                  </div>
                  <Divider type="verticle" />
                  <div class="owner">
                    <span class="title">受益人：</span>
                    <span class="content">{{gua.beneficiary}}</span>
                  </div>
                  <Divider type="verticle" />
                  <div class="owner">
                    <span class="title">业主：</span>
                    <span class="content">{{gua.ownerName}}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="isMobile">
            <div class="mobile-card-row" v-for="(gua,idx) in data" :key="idx">
              <CheckboxGroup v-model="selections" class="mobile-card-checkbox" @on-change="checkAllGroupChange">
                <Checkbox :label="gua.id">
                  <span></span>
                </Checkbox>
              </CheckboxGroup>
              <div class="mobile-card-content" @click="goToDetail(gua.orderNumber)">
                <div class="mobile-card-header-row">
                  <div class="mobile-card-prjname">{{gua.prjName}}</div>
                  <div class="mobile-card-ordernum">{{gua.orderNumber}}</div>
                </div>
                <div class="mobile-card-tags-row">
                  <Tag :color="getVarietyTagColor(gua.variety)" size="small">{{getVarietyName(gua.variety, false)}}</Tag>
                  <Tag :color="$common.guaranteeStatusColor[gua.status]" size="small">{{$common.guaranteeStatus[gua.status]}}</Tag>
                  <Tag v-if="$common.undergoingStatus.indexOf(gua.status)>-1" color="green" size="small">在保</Tag>
                  <Tag v-if="$common.undergoingStatus.indexOf(gua.status)>-1&&
                    gua.gEndDate&&require('moment')(gua.gEndDate).diff(require('moment')(),'days')<=30&&
                    gua.gEndDate&&require('moment')(gua.gEndDate).diff(require('moment')(),'days')>=0" color="orange" size="small">
                    {{require('moment')(gua.gEndDate).diff(require('moment')(), 'days')}}日到期
                  </Tag>
                  <Tag v-if="$common.undergoingStatus.indexOf(gua.status)>-1&&
                    gua.gEndDate&&require('moment')(gua.gEndDate).diff(require('moment')(),'days')<0" color="red" size="small">
                    超期
                  </Tag>
                  <Tag v-if="gua.isRenewalAuditing" color="warning" size="small">续保待审核</Tag>
                  <Tag v-if="gua.gEndDateOri" color="orange" size="small">已续保</Tag>
                </div>
                <div class="mobile-card-info">
                  <span class="mobile-card-field">{{gua.cityName}}</span>
                  <span class="mobile-card-field">{{gua.guarantorName}}</span>
                  <span class="mobile-card-field">{{(Math.round(gua.amount / 10000) / 100).toFixed(2)}}万</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </CheckboxGroup>
    </div>
    <!-- <Table ref="dataTable"
      size="small"
      :columns="columns"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table> -->
    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      :size="isMobile?'large':'small'"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      show-elevator
      show-total
      show-sizer />

    <!-- Statistics Modal -->
    <Modal v-model="statModalVisible" title="统计数据" width="700" :mask-closable="false">
      <Tabs value="statByStatus" @on-click="statTabChange">
        <TabPane label="按状态统计" name="statByStatus">
          <Table :columns="statByStatusColumns" :data="statByStatusData" size="small" :loading="statLoading"></Table>
        </TabPane>
        <TabPane label="按类别统计" name="statByVarieties">
          <Table :columns="statByVarietiesColumns" :data="statByVarietiesData" size="small" :loading="statLoading"></Table>
        </TabPane>
      </Tabs>
      <div slot="footer">
        <Button type="default" @click="statModalVisible = false">关闭</Button>
      </div>
    </Modal>

  </div>
</vue-scroll>
</template>

<script>
import * as XLSX from 'xlsx'
export default {
  name: 'guarantee-list',
  props: {
  },
  data () {
    return {
      loading: false,
      tableToolsPanel: '',
      selections: [],
      selectAll: false,
      indeterminate: false,
      columns: [
        {
          title: '选择',
          type: '_selection',
          key: 'orderNumber',
          width: 200
        },
        {
          title: '项目名称',
          key: 'prjName'
        },
        {
          title: '地区',
          key: 'cityName'
        },
        {
          title: '行业',
          key: 'industryName'
        },
        {
          title: '类型',
          key: 'varietyName'
        },
        {
          title: '保额(万)',
          key: 'amount',
          sortable: true
        },
        {
          title: '到期日',
          key: 'gEndDate',
          sortable: true
        },
        {
          title: '操作'
        }
      ],
      currentSortingColumn: {
        key: null,
        sortKey: null,
        ascending: null
      },
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        showJoint: null,
        isElec: null,
        fuzzy: null,
        orderNumber: null,
        prjName: null,
        variety: null,
        cityId: null,
        cityIds: null,
        industryId: null,
        guarantorName: null,
        contractorName: null,
        beneficiary: null,
        guaranteed: null,
        gMethod: null,
        opName: null,
        opContactTel: null,
        amountStart: null,
        amountEnd: null,
        createTimeStart: null,
        createTimeEnd: null,
        dateranage: null,
        status: null,
        statusList: null,
        expireInDays: null,
        auditTimeStart: null,
        auditTimeEnd: null,
        auditDaterange: null,
        terminateTimeStart: null,
        terminateTimeEnd: null,
        terminateDaterange: null
      },
      varieties: [],
      departments: [],
      curDepartmentId: null,
      cities: [],
      industries: [],
      projects: [],
      owners: [],
      contractors: [],
      // Statistics modal
      statModalVisible: false,
      statLoading: false,
      statByStatusColumns: [
        { title: '状态', key: 'statusName' },
        { title: '数量', key: 'count' },
        { title: '保额合计(万)', key: 'amount' },
        { title: '保证金合计(万)', key: 'deposit' }
      ],
      statByStatusData: [],
      statByVarietiesColumns: [
        { title: '类别', key: 'varietyName' },
        { title: '数量', key: 'count' },
        { title: '保额合计(万)', key: 'amount' },
        { title: '保证金合计(万)', key: 'deposit' }
      ],
      statByVarietiesData: []
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    '$route.query.orderNumber': function (newVal) {
      this.filterModel.orderNumber = newVal
      this.initData()
    },
    '$route.query.keyword': function (newVal) {
      this.filterModel.fuzzy = newVal
      this.initData()
    },
    '$route.query.elec': function (newVal) {
      if (newVal) {
        this.filterModel.isElec = true
      } else {
        this.filterModel.isElec = false
      }
      this.initData()
    },
    '$route.query.prjId': function (newVal) {
      if (newVal) {
        this.filterModel.prjId = newVal
      } else {
        this.filterModel.prjId = null
      }
      this.initData()
    },
    '$route.query.ownerId': function (newVal) {
      if (newVal) {
        this.filterModel.ownerId = newVal
      } else {
        this.filterModel.ownerId = null
      }
      this.initData()
    },
    '$route.query.contractorId': function (newVal) {
      if (newVal) {
        this.filterModel.contractorId = newVal
      } else {
        this.filterModel.contractorId = null
      }
      this.initData()
    }
  },
  computed: {
    filterExpandText () {
      return (this.tableToolsPanel.indexOf('filter') > -1 ? '隐藏'  :'展开') + '筛选条件'
    },
    isMobile () {
      return ['xs', 'sm'].indexOf(this.$store.getters.screenSize) > -1
    }
  },
  mounted () {
    if (this.$route.params.guarantor && this.$route.params.guarantor.name) {
      this.filterModel.guarantorName = this.$route.params.guarantor.name
    }
    if (this.$route.query.orderNumber) {
      this.filterModel.orderNumber = this.$route.query.orderNumber
    }
    if (this.$route.query.keyword) {
      this.filterModel.fuzzy = this.$route.query.keyword
    }
    if (this.$route.query.elec) {
      this.filterModel.isElec = true
    }
    if (this.$route.query.prjId) {
      this.filterModel.prjId = this.$route.query.prjId
    }
    if (this.$route.query.ownerId) {
      this.filterModel.ownerId = this.$route.query.ownerId
    }
    if (this.$route.query.contractorId) {
      this.filterModel.contractorId = this.$route.query.contractorId
    }
    if (this.$route.params.statusList) {
      this.filterModel.statusList = this.$route.params.statusList
    }
    if (this.$route.params.expireInDays) {
      this.filterModel.expireInDays = this.$route.params.expireInDays
    }
    this.initVarieties()
    this.initCitySelect()
    this.initIndustrySelect()
    this.initData()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    // Get supervisor's permitted city IDs (city and its children)
    getSupervisorCityFilter () {
      let userInfo = this.$store.getters.userInfo
      let userRole = this.$common.userType[userInfo.type.toString()]
      // If supervisor role, filter by cityId
      if (userRole === '监管人' && userInfo.cityId) {
        return userInfo.cityId
      }
      return null
    },
    refresh () {
      // console.log('123')
      this.currentPageIndex = 1
      this.initData()
    },
    resetFilter () {
      this.filterModel = {
        fuzzy: null,
        orderNumber: null,
        prjName: null,
        variety: null,
        cityId: null,
        industryId: null,
        guarantorName: null,
        contractorName: null,
        beneficiary: null,
        guaranteed: null,
        gMethod: null,
        opName: null,
        opContactTel: null,
        amountStart: null,
        amountEnd: null,
        createTimeStart: null,
        createTimeEnd: null,
        dateranage: null,
        isElec: null,
        status: null,
        expireInDays: null,
        auditTimeStart: null,
        auditTimeEnd: null,
        auditDaterange: null,
        terminateTimeStart: null,
        terminateTimeEnd: null,
        terminateDaterange: null
      }
      this.$refs.fiterForm.resetFields()
    },
    filterDateRangeChanged (dates) {
      if (dates instanceof Array) {
        this.filterModel.createTimeStart = require('moment')(dates[0]).format('YYYY-MM-DDT00:00:00')
        this.filterModel.createTimeEnd = require('moment')(dates[1]).format('YYYY-MM-DDT23:59:59')
      }
    },
    filterAuditDateRangeChanged (dates) {
      if (dates instanceof Array) {
        this.filterModel.auditTimeStart = require('moment')(dates[0]).format('YYYY-MM-DDT00:00:00')
        this.filterModel.auditTimeEnd = require('moment')(dates[1]).format('YYYY-MM-DDT23:59:59')
      }
    },
    filterTerminateDateRangeChanged (dates) {
      if (dates instanceof Array) {
        this.filterModel.terminateTimeStart = require('moment')(dates[0]).format('YYYY-MM-DDT00:00:00')
        this.filterModel.terminateTimeEnd = require('moment')(dates[1]).format('YYYY-MM-DDT23:59:59')
      }
    },
    sortColumn (col) {
      console.log(col)
      if (col.sortable) {
        let key = col.sortKey || col.key
        let asc = col.ascending
        console.log(asc)
        if (this.filterModel.sortBy !== key) {
          asc = true
        } else if (asc === null || asc === undefined) {
          asc = true
        } else if (asc === true) {
          asc = false
        } else {
          asc = null
          key = null
        }
        this.$nextTick(() => {
          col.ascending = asc
          this.filterModel.sortBy = key
          this.filterModel.ascending = asc
          this.currentSortingColumn = {
            key: key,
            sortKey: key,
            ascending: asc
          }
          this.refresh()
        })
      }
    },
    handleCheckAll () {
      if (this.indeterminate) {
          this.selectAll = false
      } else {
          this.selectAll = !this.selectAll
      }
      this.indeterminate = false
      if (this.selectAll) {
        this.selections = this.data.map((g) => {
          return g.id
        })
      } else {
        this.selections = []
      }
    },
    checkAllGroupChange (data) {
      if (data.length === 3) {
        this.indeterminate = false
        this.selectAll = true
      } else if (data.length > 0) {
        this.indeterminate = true
        this.selectAll = false
      } else {
        this.indeterminate = false
        this.selectAll = false
      }
    },
    exportExcel () {
      let data = []
      this.selections.forEach((id) => {
        let item = this.data.find(o => o.id === id)
        data.push(item)
      })
      this.doExport(data)
    },
    doExport (data) {
      let rows = data.map((d) => {
        return {
          ID: d.id,
          保函编号: d.orderNumber,
          担保种类: d.varietyName,
          担保方式: d.gMethod===0 ? '独立保证' : '联合保证',
          状态: this.$common.guaranteeStatus[d.status],
          地区: d.cityName,
          行业: d.industryName,
          项目名称: d.prjName,
          担保金额: d.amount / 100,
          担保费率: d.gFeeRate > 0 ? Math.round(d.gFeeRate * 100) / 100 + '%·月' : '',
          业主: d.ownerName,
          保证人: d.guarantorName,
          被保证人: d.guaranteed,
          受益人: d.beneficiary,
          承包商: d.contractorName,
          创建时间: d.createTime ? this.$moment(d.createTime).format('YYYY-MM-DD HH:mm:ss') : '',
          保函生效时间: d.gStartDate ? this.$moment(d.gStartDate).format('YYYY-MM-DD HH:mm:ss') : '',
          保函截止时间: d.gEndDate ? this.$moment(d.gEndDate).format('YYYY-MM-DD HH:mm:ss') : '',
          审核时间: d.auditTime ? this.$moment(d.auditTime).format('YYYY-MM-DD HH:mm:ss') : '',
          解保时间: d.terminateTime ? this.$moment(d.terminateTime).format('YYYY-MM-DD HH:mm:ss') : ''
        }
      })
      const worksheet = XLSX.utils.json_to_sheet(rows)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '导出')
      XLSX.writeFile(workbook, `保函列表导出@${this.$moment().format('YYYYMMDDHHmmss')}.xlsx`, { compression: true })
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    initVarieties () {
      this.$Api.Guarantee.getGuaranteeVarieties('ALL')
      .then((res) => {
        this.varieties = res
      })
      .catch(err => {
        this.$Message.error(err.message)
      })
    },
    getVarietyName (varietyId, isFullName = false) {
      if (this.varieties && this.varieties.length) {
        let v = this.varieties.find(o => o.id === varietyId)
        if (!v) {
          return '未知'
        }
        if (isFullName) {
          return v.fullName
        } else {
          return v.name
        }
      }
    },
    getVarietyTagColor (varietyId) {
      return this.$common.guaranteeVarietyColor[varietyId]
    },
    initIndustrySelect () {
      this.$Api.Industry.listIndustries({
      }, 1, 1000).then((res) => {
        let data = res.data.map((c) => {
          return {
            id: c.id,
            value: c.id,
            label: c.name
          }
        })
        this.industries = data
      }).catch(err => {
        this.$Message.error('获取行业列表失败!' + err.message)
      })
    },
    initCitySelect (...args) {
      this.$store.dispatch('setSmsVerifierCallbackFn', this.initCitySelect)
      this.$store.dispatch('setSmsVerifierCallbackArgs', args)
      this.$Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      this.$Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val, selected) {
      console.log(val, selected)
      let lastSelected = selected.length ? selected[selected.length - 1] : null
      if (lastSelected) {
        console.log(lastSelected)
        let cities = []
        let city 
        this.cities.map((c) => {
          if (c.value === lastSelected.value && c.label !== '本级') {
            city = c
          } else {
            if (c.children) {
              c.children.forEach((cl) => {
                if (cl.value === lastSelected.value && cl.label !== '本级') {
                  city = cl
                }
                if (cl.children) {
                  cl.children.forEach(cg => {
                    if (cg.value === lastSelected.value && cg.label !== '本级') {
                      city = cg
                    }
                  })
                }
              })
            }
          }
        })
        console.log(city)
        cities.push(city.value)
        if (city.children) {
          city.children.forEach(cl => {
            cities.push(cl.value)
            if (cl.children) {
              cl.children.forEach(cg => {
                cities.push(cg.value)
              })
            }
          })
        }
        this.filterModel.cityIds = cities
      }
    },
    selectProject (prj) {
      this.filterModel.prjName = prj.value
    },
    createPrjName (query) {
      console.log(query, this.projects)
      this.projects.push({
        name: query,
        id: 0
      })
    },
    searchProjects (query) {
      this.$Api.Project.searchProjects({
        name: query
      }, 1, 1000).then((prjs) => {
        this.projects = prjs.data
      }).catch(err => {
        this.$Message.error('获取项目列表失败!' + err.message)
      })
    },
    selectOwner (own) {
      this.filterModel.ownerName = own.value
    },
    createOwnerName (query) {
      this.owners.push({
        name: query,
        id: 0
      })
    },
    searchOwners (query) {
      this.$Api.Company.listCompanies({
        isLocal: null,
        name: query,
        type: 4
      }, 1, 1000).then((companies) => {
        this.owners = companies.data
      }).catch(err => {
        this.$Message.error('获取业主列表失败!' + err.message)
      })
    },
    selectContractor (company) {
      this.filterModel.contractorName = company.value
    },
    createContractorName (query) {
      this.contractors.push({
        name: query,
        id: 0
      })
    },
    searchContractors (query) {
      this.$Api.Company.listCompanies({
        isLocal: null,
        name: query,
        type: 1
      }, 1, 1000).then((companies) => {
        this.contractors = companies.data
      }).catch(err => {
        this.$Message.error('获取承包商列表失败!' + err.message)
      })
    },
    async initData () {
      this.$Spin.show()
      // Apply supervisor city filter if applicable
      let filter = Object.assign({}, this.filterModel)
      let supvCityFilter = this.getSupervisorCityFilter()
      if (supvCityFilter && !filter.cityId) {
        filter.cityId = supvCityFilter
      }
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] != '承保人')  {
        filter.excludeStatus = [7]
      }
      let res = await this.$Api.Guarantee.listGuarantees(filter, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.currentPageIndex = res.currentPage
      this.pageSize = res.pageSize
      this.data = res.data
      this.$Spin.hide()
    },
    async deleteGuarantor (tId) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该企业么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Guarantor.deleteGuarantor(tId).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.data.splice(this.data.findIndex(o => {return o.id === tId}), 1)
          this.totalCount -= 1
        },
        onCancel: () => {
        }
      })
    },
    edit (orderNumber) {
      this.$router.push({path: '/guarantees/new/' + orderNumber})
    },
    goToDetail (orderNumber) {
      this.$router.push({path: '/guarantees/detail/' + orderNumber})
    },
    async remove (orderNumber) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该保函记录么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Guarantee.deleteGuarantee(orderNumber).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.refresh()
        },
        onCancel: () => {
        }
      })
    },
    async openStatModal () {
      this.statModalVisible = true
      this.statLoading = true
      // Build filter params from current filterModel
      let filter = Object.assign({}, this.filterModel)
      let supvCityFilter = this.getSupervisorCityFilter()
      if (supvCityFilter && !filter.cityId) {
        filter.cityId = supvCityFilter
      }
      // Add GuaranteeTids if selections exist
      if (this.selections && this.selections.length > 0) {
        filter.guaranteeTids = this.selections
      }
      try {
        let res = await this.$Api.Statistics.guaranteeStatistics(filter)
        if (res.statByStatus && res.statByStatus.length) {
          this.statByStatusData = res.statByStatus.map(item => {
            return {
              statusName: this.$common.guaranteeStatus[item.status] || '未知',
              count: item.count,
              amount: (Math.round(item.amount / 10000) / 100).toFixed(2),
              deposit: (Math.round(item.deposit / 10000) / 100).toFixed(2)
            }
          })
        } else {
          this.statByStatusData = []
        }
        if (res.statByVarieties && res.statByVarieties.length) {
          this.statByVarietiesData = res.statByVarieties.map(item => {
            return {
              varietyName: this.getVarietyName(item.varietyId, false) || '未知',
              count: item.count,
              amount: (Math.round(item.amount / 10000) / 100).toFixed(2),
              deposit: (Math.round(item.deposit / 10000) / 100).toFixed(2)
            }
          })
        } else {
          this.statByVarietiesData = []
        }
      } catch (err) {
        this.$Message.error('获取统计数据失败: ' + err.message)
      } finally {
        this.statLoading = false
      }
    },
    statTabChange () {
      // Tab change handler if needed
    }
  }
}
</script>

<style lang="less" scoped>
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
@media (max-width: 768px) {
  .pager {
    text-align: center;
  }
  .pager ::v-deep .ivu-page-options {
    display: none !important;
  }
  .pager ::v-deep .ivu-page-item,
  .pager ::v-deep .ivu-page-prev,
  .pager ::v-deep .ivu-page-next
  .pager ::v-deep .ivu-page-total {
    min-width: 36px;
    height: 36px;
    line-height: 36px;
  }
  /* .pager {
    ::v-deep .ivu-page-size-selector {
      display: none;
    }
    ::v-deep .ivu-page-elevator {
      display: none;
    }
    ::v-deep .ivu-page-item, .ivu-page-prev, .ivu-page-next {
      min-width: 36px;
      height: 36px;
      line-height: 36px;
    }
  } */
}
.list-table {
  td {
    word-break: break-all;
  }
  .table-header {
    background: #efefef;
    margin-bottom: 10px;
    & > table {
      border-collapse: collapse;
      & > thead {
        border: 1px solid #ddd;
        th {
          padding: 8px 5px;
        }
      }
    }
  }
  .mobile-table-header {
    & > table {
      & > thead {
        th {
          padding: 6px 4px;
          font-size: 12px;
        }
      }
    }
  }
  .table-body {
    & > .data-row {
      position: relative;
      border: 1px solid #eee;
      transition: all .3s linear;
      margin-bottom: 10px;
      background: #f8faff;
      .status-badge {
        position: absolute;
        right: 0;
        top: 0;
      }
      .data-row-header {
        .line {
          display: flex;
          flex-direction: row;
          // background: #f5f5f5;
          padding: 5px 10px;
          align-items: center;
          // font-size: 12px;
          color: #777;
        }
        .order-number {
          // font-weight: bold;
          font-style: italic;
          // color: #3855b8;
        }
      }
      .data-row-footer {
        transition: all .3s linear;
        border-top: 1px dotted #f2f2f2;
        margin: 5px 10px 0 10px;
        padding: 5px;
        font-size: 12px;
        .line {
          display: flex;
          flex-direction: row;
          align-items: center;
          color: #777;
        }
      }
      & > table {
        border-collapse: collapse;
        & > tbody {
          td {
            padding: 5px;
            text-align: center;
            // .prjname {
            //   white-space: nowrap;
            //   text-overflow: ellipsis;
            // }
          }
        }
      }
      &:hover {
        border: 1px solid #3855b8;
        .data-row-footer {
          border-top: 1px dotted #ccc;
        }
      }
    }
  }
}
/* Mobile filter styles */
.mobile-filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
  .mobile-filter-item {
    flex: 1;
    min-width: 40%;
    margin-bottom: 0;
  }
}
.mobile-filter-row-buttons {
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
}
/* Mobile card row styles */
.mobile-card-row {
  display: flex;
  border: 1px solid #eee;
  margin-bottom: 10px;
  background: #f8faff;
  padding: 10px;
  border-radius: 4px;
  .mobile-card-checkbox::deep {
    display: flex;
    align-items: flex-start;
    padding-top: 2px;
    .ivu-checkbox-label {
      display: none;
    }
  }
  .mobile-card-content {
    flex: 1;
    padding-left: 8px;
    .mobile-card-header-row {
      margin-bottom: 8px;
    }
    .mobile-card-prjname {
      font-weight: bold;
      font-size: 14px;
      color: #333;
      word-break: break-all;
      line-height: 1.3;
    }
    .mobile-card-ordernum {
      font-size: 12px;
      color: #888;
      font-style: italic;
      margin-top: 4px;
    }
    .mobile-card-tags-row {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      margin-bottom: 8px;
    }
    .mobile-card-info {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      font-size: 12px;
      .mobile-card-field {
        color: #666;
      }
    }
    &:hover {
      border: 1px solid #3855b8;
    }
  }
}
@media (max-width: 768px) {
  .mobile-card-row {
    cursor: pointer;
  }
}
</style>
